import { render, staticRenderFns } from "./Captains.vue?vue&type=template&id=39c74abd"
import script from "./Captains.vue?vue&type=script&lang=js"
export * from "./Captains.vue?vue&type=script&lang=js"
import style0 from "./Captains.vue?vue&type=style&index=0&id=39c74abd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports